<template>
  <div class="placeholder" :class="icon" :data-qa="`placeholder-${qaName}-block`">
    <div
      class="placeholder-icon"
      :style="{
        width: `${iconWidth}px`,
        minWidth: `${iconWidth}px`,
        height: `${iconHeight}px`,
        minHeight: `${iconHeight}px`
      }"
      :class="icon"
      v-if="icon"
      :data-qa="`placeholder-${qaName}-icon`"
    ></div>
    <span class="placeholder-message" :data-qa="`placeholder-${qaName}-message`">{{ message }}</span>
    <span class="placeholder-description" :data-qa="`placeholder-${qaName}-description`">{{ description }}</span>
    <VitaButton
      v-if="onRefreshClick"
      type="clear"
      button-type="button"
      class="placeholder-btn"
      :disabled="refreshBtnDisabled"
      @click="onRefreshClick"
      :data-qa="`placeholder-${qaName}-button-refresh`"
    >
      <vita-icon name="update"/>
      <span>Обновить</span>
    </VitaButton>
  </div>
</template>

<script lang="ts" setup>
import VitaButton from './VitaButton.vue'
import VitaIcon from './VitaIcon.vue'

interface Props {
  /** Описание заглушки и её статуса/типа для data-qa, напр. "beru-free-empty" */
  qaName: string
  icon?: string
  iconWidth?: string
  iconHeight?: string
  message: string
  description?: string
  onRefreshClick?: () => void
  refreshBtnDisabled?: boolean
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.placeholder-icon {
  min-width: 200px;
  width: 200px;
  height: 200px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &.isEmpty {
    background-image: url('@/static/img/empty.svg');
  }

  &.isEmptyWindow {
    background-image: url('@/static/img/empty-window.svg');
  }

  &.isEmptyBox {
    background-image: url('@/static/img/empty-box.svg');
  }

  &.isOffline {
    background-image: url('@/static/img/offline.svg');
  }
}

.placeholder-message {
  display: block;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: 0;
  text-align: center;
  color: #333333;
  max-width: 315px;
  word-break: break-word;

  &:not(:first-child) {
    margin-top: 24px;
  }
}

.placeholder-description {
  font-weight: 500;
  font-size: 13px;
  line-height: 1.25;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #888888;
  max-width: 315px;

  &:not(:first-child) {
    margin-top: 8px;
  }
}

.placeholder-btn {
  background-color: transparent;
  color: rgba(48, 168, 255, 1);
  border: none;
  padding: 6px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;

  span {
    color: rgb(48, 168, 255);
    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0%;
  }
}
</style>
